import { render, staticRenderFns } from "./ClientesOdooView.vue?vue&type=template&id=3d01b3c0"
import script from "./ClientesOdooView.vue?vue&type=script&lang=js"
export * from "./ClientesOdooView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports